import { z } from "zod";
/**
 * Pre-action: an automated interaction the tour runtime performs
 * before highlighting a step's target. V1 supports `click` only.
 *
 * Motivating use case: a step that points at "Settings" inside a
 * collapsed sidebar opens the sidebar first (click), waits a beat
 * for the open animation to settle, then proceeds to highlight
 * the menu item.
 *
 * Pre-actions replay every time the step is shown — including when
 * a user jumps back via the tour table of contents — so authoring
 * guidance steers admins toward controls that no-op on re-click
 * (open/expand controls, not toggles).
 *
 * Future kinds (hover, type, scroll, submit, wait-for-selector)
 * extend the discriminated union without a schema migration.
 */
export const preActionSchema = z.discriminatedUnion("kind", [
    z.object({
        kind: z.literal("click"),
        selector: z.string().min(1).max(500),
        settleMs: z.number().int().min(0).max(2000).default(150),
    }),
]);
